import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  home_page: {},
  null_search_page: {},
  company_page: [],
  distributor_page: [],
  browse_company: [],
  subscription_config: {},
};

const cmsPageSlice = createSlice({
  name: "storeList",
  initialState,
  reducers: {
    setHomepage: (state, action) => {
      state.home_page = action.payload;
    },
    setNullSearchpage: (state, action) => {
      state.null_search_page = action.payload;
    },
    setComapanyPage: (state, action) => {
      const newItem = action.payload;
      const exists = state.company_page.some(
        (item) => item.cid === newItem.cid
      );
      if (!exists) {
        state.company_page.push(newItem);
      }
    },
    setDistributorpage: (state, action) => {
      const newItem = action.payload;
      const exists = state.distributor_page.some(
        (item) => item.sid === newItem.sid
      );
      if (!exists) {
        state.distributor_page.push(newItem);
      }
    },
    setBrowseCompany: (state, action) => {
      state.browse_company = action.payload;
    },
    clearCMSpages: (state) => {
      state.home_page = {};
      state.null_search_page = {};
      state.company_page = [];
      state.distributor_page = [];
      state.browse_company = [];
      state.subscription_config = {};
    },
    setSubscriptionConfig: (state, action) => {
      state.subscription_config = action.payload;
    },
  },
});

export const {
  setHomepage,
  setNullSearchpage,
  setComapanyPage,
  setDistributorpage,
  setBrowseCompany,
  setSubscriptionConfig,
} = cmsPageSlice.actions;

export default cmsPageSlice.reducer;
